/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { UserItem } from '../../models/user-item';

export interface IdentityControllerGetOne$Params {
  id: number;
}

export function identityControllerGetOne(http: HttpClient, rootUrl: string, params: IdentityControllerGetOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
  const rb = new RequestBuilder(rootUrl, identityControllerGetOne.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: UserItem;
      }>;
    })
  );
}

identityControllerGetOne.PATH = '/identity/{id}';
